/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Extraction_CompleteInputs */

const en_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource extraction complete. Uploading...`)
};

const fr_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction des ressources terminée. Chargement en cours...`)
};

const de_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcenextraktion abgeschlossen. Hochladen...`)
};

const it_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione delle risorse completata. Caricamento in corso...`)
};

const ru_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение ресурсов завершено. Загрузка...`)
};

const es_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracción de recursos completada. Subiendo...`)
};

const zh_cn2_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源提取完成。正在上传……`)
};

const ja_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リソースの抽出が完了しました。アップロード中です...`)
};

const hi_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संसाधन निष्कर्षण पूर्ण हो गया है। अपलोड हो रहा है...`)
};

const pt_pt2_ad_extraction_complete = /** @type {(inputs: Ad_Extraction_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extração de recursos concluída. Enviando...`)
};

/**
* | output |
* | --- |
* | "Resource extraction complete. Uploading..." |
*
* @param {Ad_Extraction_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_extraction_complete = /** @type {((inputs?: Ad_Extraction_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Extraction_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_extraction_complete(inputs)
	if (locale === "de") return de_ad_extraction_complete(inputs)
	if (locale === "it") return it_ad_extraction_complete(inputs)
	if (locale === "ru") return ru_ad_extraction_complete(inputs)
	if (locale === "es") return es_ad_extraction_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_extraction_complete(inputs)
	if (locale === "ja") return ja_ad_extraction_complete(inputs)
	if (locale === "hi") return hi_ad_extraction_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_extraction_complete(inputs)
	return en_ad_extraction_complete(inputs)
});